var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn_next") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_Landing-page",
    transform: "translate(-1325, -2853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn",
    transform: "translate(1235, 2853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn_next",
    transform: "translate(90, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#040802",
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_next",
    transform: "translate(32.3091, 30.0013) scale(1, -1) translate(-32.3091, -30.0013)translate(18.43, 20)",
    fill: "#040802",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3762227,0.289773261 C18.0735643,-0.0633458818 17.4996817,-0.102278717 17.1214024,0.220157426 C16.7400135,0.54516629 16.6956865,1.11625065 17.0093855,1.48124171 L17.0701758,1.54712401 C17.0867081,1.56357362 17.103793,1.57930076 17.150366,1.62095815 L23.8315196,8.2794384 L24.6839836,9.12900942 L23.4804701,9.13358859 L0.896244,9.21734504 C0.40598712,9.21723234 0.000567672335,9.6237762 0,10.0980049 L0.004741,10.2094628 C0.0489251782,10.6702801 0.440001477,11.0264011 0.907726,11.0264046 L23.4106799,10.9435958 L24.6282875,10.9389986 L23.7652944,11.7979703 L17.0922584,18.4376926 C16.7373135,18.7389355 16.6982701,19.3099972 17.0222635,19.6863755 C17.3489094,20.0658351 17.9227291,20.1100451 18.3039158,19.7851308 C18.3398733,19.7544616 18.3730267,19.7214672 18.4297859,19.6577484 L27.4929358,10.6413038 C27.8463785,10.2875734 27.8463558,9.71774393 27.4938738,9.36489463 L18.3762227,0.289773261 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnNext);
export default __webpack_public_path__ + "static/media/btn_next.bc6509f9c8adcf06b812779e8de2a416.svg";
export { ForwardRef as ReactComponent };